//
//
//
//
//
//
//

export default {
  components: {
  },
  data () {
    return {
      linkMeFlag: false
    }
  },
  methods: {
    linkMeOver () {
      this.linkMeFlag = true
    },
    linkMeOut () {
      this.linkMeFlag = false
    }
  },
  mounted () {
  }
}
